
import { Routes, Route } from 'react-router-dom';
import './App.css';
import MainLayout from './layouts/MainLayout';
import PlainLayout from './layouts/PlainLayout';
import EntryPage from './pages/EntryPage';
import About from './pages/About';
import Registration from './pages/Registration';
import TermsPrivacy from './pages/TermsPrivacy';
import Payment from './pages/Payment';
import Events from './pages/Events';


function App() {
  return (
    <Routes>
      {/* Pages WITH layout */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Registration />} />
        <Route path="/about" element={<About />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/events" element={<Events />} />
        <Route path="/terms-and-privacy" element={<TermsPrivacy />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/success" element={<Payment result="success" />} />
        <Route path="/cancel" element={<Payment result="cancel" />} />
      </Route>

      {/* Pages WITHOUT layout */}
      <Route element={<PlainLayout />}>
      </Route>
    </Routes>
  );
}

export default App;
